var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeedmapLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 20",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.028.492v1.37h.04c.367-.521.81-.926 1.329-1.214.518-.287 1.113-.43 1.782-.43.643 0 1.23.124 1.763.371.531.248.935.686 1.21 1.313.302-.445.713-.836 1.231-1.176.519-.34 1.132-.509 1.842-.509a5.5 5.5 0 0 1 1.496.196c.46.13.853.339 1.181.626.329.288.584.663.768 1.127.185.463.276 1.022.276 1.675v6.775H30.15V4.879c0-.34-.013-.66-.04-.96a2.023 2.023 0 0 0-.216-.784 1.313 1.313 0 0 0-.522-.528c-.23-.13-.542-.197-.935-.197-.394 0-.712.076-.955.226a1.63 1.63 0 0 0-.571.588c-.138.24-.23.516-.276.823a6.254 6.254 0 0 0-.07.93v5.639H23.77v-5.68c0-.3-.006-.597-.019-.89a2.49 2.49 0 0 0-.167-.813 1.254 1.254 0 0 0-.492-.597c-.23-.15-.569-.226-1.015-.226-.131 0-.305.03-.522.089-.216.058-.427.17-.63.333-.204.163-.377.398-.521.705-.146.307-.217.709-.217 1.205v5.874H17.39V.492h2.638ZM9.769 10.616 7.957 3.82h-.04l-1.732 6.795H3.29L.06.492h2.955l1.87 6.873h.04L6.618.492h2.718l1.733 6.854h.04l1.87-6.854h2.875l-3.21 10.124H9.77Z",
    fill: "#00cdbe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.622 16.549c6.045 0 9.104-2.283 9.104-2.283l1.301 1.75s-4.514 3.805-10.405 3.805c-5.891 0-10.405-3.805-10.405-3.805l1.301-1.75s3.06 2.283 9.104 2.283Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeedmapLogo);
export default __webpack_public_path__ + "static/media/weedmap_logo.f01a5a4ae0399d396ccede6be7e819ee.svg";
export { ForwardRef as ReactComponent };